import { array } from "prop-types";
import React from "react";
import { useRef, useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { postRunbookFeedback, getRunbookFeedbacks } from "store/actions";

const Feedback = ({id}) => {
  const dispatch = useDispatch();
  const text = useRef(null);
  const { feedbackPost } = useSelector(state => ({feedbackPost: state.AlertLog.data}))

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const stars = Array(5).fill('☆');
  const [value, setValue] = useState(1);

  useEffect(() => {
    setRatingValue(4)
  }, [])

  const setRatingValue = (index) => {
    setValue(index);
  };

  const getText = () => {
    setLoading(true);
    let payload = {
      "runbook_id": id,
      "rating": value + 1, 
      "textual_feedback": text.current.value
    };
    dispatch(postRunbookFeedback(payload));
    setLoading(false);
    setSubmitted(true);
    submitted && dispatch(getRunbookFeedbacks(id));
    text.current.value = ""
  };

  return (
    <React.Fragment>
       <style>
        {`
          .custom-placeholder::placeholder {
            color: #4C5570;
            font-size: 1rem;
            text-align: left;
          }
        `}
      </style>
      <div className="d-flex justify-content-center my-4">
         
        <div className="py-3" style={{width:"90%"}}>
        <h1 className="mb-3" style={{fontSize: "1.2rem", color:"#DBE1F5"}}>Feedback</h1>
        <div className="d-flex-column">
          <div className="d-flex-column mb-4">
          <span style={{color:"#DBE1F5"}}>How would you rate this runbook</span>
          <div className="d-flex align-items-center gap-3">
            <div>
          
          {stars.map((item, index) => (
            <span
              onClick={() => setRatingValue(index)}
              key={index+1}
              style={{ cursor: 'pointer', fontSize:"24px", padding:"0px 0px 0px 8px" }}
            >
              {index <= value ? "★" : item}
            </span>     
          ))}
          </div>
          </div>
       </div>

          <div className="d-flex-column justify-content-around" >

            <div>
            <p style={{color:"#DBE1F5"}}>Anything you'd like to add</p>
            <textarea disabled={submitted} className="form-control custom-placeholder p-4" placeholder="Type here" style={{height:"200px", border:"1px solid rgb(white, 0.6)", borderRadius:"12px"}} ref={text}></textarea>
            </div>
            <div className="position-relative">
              <div className="w-100 d-flex justify-content-end mt-4">
                {submitted ?<div> <div className="badge-soft-success me-1 badge bg-secondary mb-2" style={{fontSize: "1rem"}}>Feedback submitted</div><p>Thank you for the feedback</p> </div>:
                 (loading ? <div className="spinner-border text-primary"></div> :    
                  <button className="btn btn-primary mt-2 ml-auto " onClick={getText}>Submit Feedback</button>    
                  )}
              </div>
            </div>
           </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Feedback;